import moment from "moment";

export const getApexChartOptions = (data) => {

    let options = {
        chart: {
            id: data.name,
            type: 'line',
            zoom: {
                enabled: false
            },
            animations: {
                enabled: false,
                easing: 'linear',
                animateGradually: {
                    enabled: true,
                    // speed: 150
                },
                //   dynamicAnimation: {
                //     speed: 500
                //   }
            },
            toolbar: {
                show: false,
                tools: {
                    download: false
                }
            }
        },
        grid: {
            show: false,      // can either change here to disable all grids
            xaxis: {
                lines: {
                    show: true
                }
            },
            yaxis: {
                lines: {
                    show: true
                }
            },
        },
        stroke: {
            show: true,
            curve: 'smooth',
            lineCap: 'round',
            colors: [data.lineColor],
            width: 2,
            dashArray: 0,
        },
        xaxis: {
            show: data.showXAxis ? true : false,
            tickAmount: 8,
            // forceNiceScale: true,
            type: "datetime",
            range: data.range,
            // tickPlacement: 'between',
            position: 'bottom',
            labels: {
                show: data.showXAxis ? true : false,
                formatter: function (value, timestamp) {
                    return moment(timestamp).format("hh:mm:ss");
                },
                style: {
                    colors: ['#707070'],
                    // fontSize: '12px',
                    // fontFamily: 'Open Sans',
                    font: 'normal normal 600 20px/30px Open Sans',
                    letterSpacing: '0px',
                    fontWeight: 400,
                    // cssClass: 'apexcharts-xaxis-label',
                }
            },
            axisBorder: {
                show: data.showXAxis ? true : false
            }
        },
        yaxis: {
            show: true,
            // showAlways: true,
            // showForNullSeries: true,
            tickAmount: data.yTickPoint,
            min: data.yMin,
            max: data.yMax,
            // forceNiceScale: true,
            labels: {
                show: data.showYAxis ? true : false,
                align: 'right',
                formatter: val => val.toFixed(0),
                style: {
                    colors: ['#707070'],
                    // fontSize: '12px',
                    // fontFamily: 'Open Sans',
                    font: 'normal normal 600 20px/30px Open Sans',
                    fontWeight: 400,
                    cssClass: 'apexcharts-xaxis-label',
                }
            },
            // title: {
            //     text: data.yTitle,
            //     rotate: -45,
            //     offsetX: 0,
            //     offsetY: 0,
            //     align: 'right',
            //     // marginLeft: '700px',
            //     style: {
            //         color: data.yColor,
            //         fontSize: '12px',
            //         fontFamily: 'Open Sans',
            //         fontWeight: 600,
            //         cssClass: 'apexcharts-yaxis-title',
            //     },
            // },
            // axisBorder: {
            //     show: true,
            //     // color: '#707070',
            //     offsetX: 0,
            //     offsetY: 0
            // }
        }
    };

    return options;
}